<template>
	<div class="wrap">
		<div class="insidebanner">
			<img src="../assets/agent/banner.jpg" alt="">
			<span class="insidebanner-bor"></span>
		</div>
		<div class="content">
			<div class="adv">
				<div class="title">
					<h4>与我们合作的优势</h4>
					<img src="../assets/agent/en_01.png" alt="">
				</div>
				<div class="adv-cont">
					<div class="adv-cont-list">
						<dl>
							<dt><img src="../assets/agent/adv_01.png" alt=""></dt>
							<dd>
								<span class="num">1</span>
								<p>KA的幼教业务面向中国广大的公办和民办幼儿园</p>
							</dd>
						</dl>
						<dl>
							<dt><img src="../assets/agent/adv_02.png" alt=""></dt>
							<dd>
								<span class="num">2</span>
								<p>KA拥有自主研发、幼教内容与互联网深度结合的赋能产品体系</p>
							</dd>
						</dl>
						<dl>
							<dt><img src="../assets/agent/adv_03.png" alt=""></dt>
							<dd>
								<span class="num">3</span>
								<p>KA重服务重体验，提供国际化、品质化、个性化的用户服务</p>
							</dd>
						</dl>
						<dl>
							<dt><img src="../assets/agent/adv_04.png" alt=""></dt>
							<dd>
								<span class="num">4</span>
								<p>KA对代理商不收取任何代理费、合作零门槛</p>
							</dd>
						</dl>
					</div>
				</div>
			</div>
			<div class="pro">
				<div class="title">
					<h4>合作产品内容</h4>
					<img src="../assets/agent/en_02.png" alt="">
				</div>
				<div class="pro-cont">
					<div class="pro-o">
						<img class="pro-o-pic" src="../assets/agent/pro_01.png" alt="">
						<div class="pro-o-txt pro-title">
							<h4>KA互联网三端产品柚子通：</h4>
							<p>KA推出的面向幼儿园的互联网升级服务产品，旨在通过互联网连接<strong>幼儿园、教师、家长</strong>，并与线下培训服务相结合以提升幼儿园办园品质。使用柚子通可以让园所规范管理和运营，打造高品质的幼儿园，提升工作效率，降低运营成本，为园所积累无形的数据资产；对于教师则可以提高工作效率，提升教学水平和教学质量，获得家长更高的满意度；对于家长不但提升自身育儿能力，还能实现家园共育，共同提升教育效率与质量。</p>
						</div>
					</div>
					<div class="pro-two">
						<img class="pro-two-pic" src="../assets/agent/pro_02.png" alt="">
						<div class="pro-two-txt pro-title">
							<h4>KA国际双语美食课程：</h4>
							<p>课程中包括来自<strong>世界各个文化和地域的美食</strong>，让幼儿通过烹饪探索和感受不同的地域文化。为幼儿创造<strong>了解营养膳食和养成健康饮食习惯的学习环境和体验</strong>。在课堂中培养幼儿良好的餐桌礼仪。丰富多彩的延伸活动，<strong>包括艺术、互动游戏、歌曲</strong>，让幼儿在锻炼小肌肉的同时增强语言能力。</p>
						</div>
					</div>
					<div class="pro-thr">
						<img class="pro-thr-pic" src="../assets/agent/pro_03.png" alt="">
						<div class="pro-thr-txt pro-title">
							<h4>KA创享美学课程：</h4>
							<p>课程通过八大模块：<strong>线条涂绘、形状探索、色彩艺术、幼儿绘画、创意美术、我的世界、自然工坊和节日文化</strong>，帮助幼儿系统地建立从美术启蒙到审美知识的结构。课程内容选择都来源于幼儿不同的年龄特征和认知特点，所以课程的知识结构具有层次性、题材内容选择上也有一定的层次性。</p>
						</div>
					</div>
					<div class="pro-four">
						<img class="pro-four-pic" src="../assets/agent/pro_04.png" alt="">
						<div class="pro-four-txt pro-title">
							<h4>KA体适能课程：</h4>
							<p>课程囊括以趣味游戏为载体的<strong>体育技能教育、瑜伽拉伸活动、音乐律动活动、室内体育延伸活动、家校运动会活动策划包、每日健康小贴士等</strong>板块。为教师与学生提供多味一体的独特体育教学体验。所有的活动配有<strong>图卡、技能展示卡、海报、音乐等</strong>教学辅助材料。</p>
						</div>
					</div>
				</div>
			</div>
			<div class="coo">
				<div class="coo-o">
					<div class="cwidth">
						<div class="coo-o-cont">
							<div class="title">
								<h4>合作扶持政策</h4>
								<img src="../assets/agent/en_03.png" alt="">
							</div>
							<ul class="coo-o-cont-list">
								<li class="red">①、KA致力于联合各地区的优秀代理商一同分享广阔的幼儿教育市场</li>
								<li class="yellow">②、通过KA自身高水平的技术研发能力，输出高品质的产品服务作为核心保障</li>
								<li class="red">③、追求高品质的同时，KA一贯坚持合理的价格，以确保代理商利益</li>
								<li class="yellow">④、KA将公司和集团的各种资源都做到支持到位，以保证对代理商的扶持力度</li>
							</ul>
							<div class="coo-o-cont-txt">
								<p>a）通过开设推广会议、下派专业人员协助等方式</p>
								<p>b）提供资料及信息等内容支持</p>
								<p>c）合作代理商享有KA其他经营项目及产品的优先合作权</p>
								<p>d）提供专业知识、营销话术、软件操作等线上或线下培训</p>
								<p>e）负责线上产品维护，在服务过程中提供技术指导与支持</p>
							</div>
							<img class="coo-o-cont-pic" src="../assets/agent/fly.png" alt="">
						</div>
					</div>
				</div>
				<div class="coo-two">
					<div class="cwidth">
						<div class="coo-two-cont">
							<div class="title">
								<h4>合作前景</h4>
								<img src="../assets/agent/en_04.png" alt="">
								<span class="title-line"></span>
							</div>
							<p>对于代理商来说，<br>KA儿童之家从<strong>技术研发、产品价格、售后服务</strong><br>均有科学的保证，<br>并将公司和集团的各种资源都做到支持到位！</p>
							<p>受地域、消费习惯、经济差异等不同因素的影响，<br>不管您是经商多年还是初次创业，<br>都能够在短时间内步入正轨，稳健发展。<br>行业发展大潮之下，找一个钢性市场与专业的<br>合作伙伴是最为明智的选择。</p>
						</div>
					</div>
				</div>
				<div class="coo-thr">
					<div class="coo-thr-cont">
						<div class="title">
							<h4>合作要求</h4>
							<img src="../assets/agent/en_05.png" alt="">
							<span class="title-line"></span>
						</div>
						<img class="coo-thr-pic" src="../assets/agent/coo_thr_01.png" alt="">
						<img class="coo-thr-pic" src="../assets/agent/coo_thr_02.png" alt="">
					</div>
				</div>
				<div class="coo-four">
					<div class="title">
						<h4>合作咨询</h4>
						<img src="../assets/agent/en_06.png" alt="">
						<span class="title-line"></span>
					</div>
					<p>4000 - 010203</p>
				</div>
			</div>
		
		</div>
	</div>
</template>
<script>
	export default {
		name: 'Agent',
		data () {
			return {}
		}
	}
</script>
<style lang="scss" scoped>
	@import '../base/scss/mixin';
	.wrap {
		padding-top: 80px;
	}
	.content {
		.title {
			text-align: center;
			h4 {
				font-weight: normal;
				font-size: 28px;
				color: #1d50a2;
			}
			&-line {
				width: 294px;
				height: 5px;
				display: block;
				background: url(../assets/agent/title_line.png) left top no-repeat;
			}
		}
	}
	.adv {
		height: 705px - 70px;
		padding-top: 70px;
		background: url(../assets/agent/bg_01.png) center top no-repeat;
		.title {
			margin-bottom: 12px;
			h4 {
				margin-bottom: 6px;
			}
		}
		&-cont {
			@extend %width;
			&-list {
				@extend %clearfix;
				margin-left: 25px;
				margin-right: -58px;
			}
			
			dl {
				float: left;
				width: 520px;
				margin-right: 58px;
				margin-bottom: 36px;
				&:hover {
					img {
						animation-name: bounce;
						animation-duration: 1s;
						animation-fill-mode: both;
						transform-origin: center bottom;
					}
				}
			}
			dt {
				height: 138px;
				line-height: 138px;
				text-align: center;
				margin-bottom: 12px;
				padding-bottom: 10px;
				background: url(../assets/agent/adv_01bg.png) center bottom no-repeat;
				img {
					vertical-align: bottom;
				}
			}
			dd {
				position: relative;
				height: 46px;
			}
			p {
				height: 42px;
				line-height: 42px;
				padding-left: 46px;
				margin-left: 28px;
				border: 2px solid #f4bc16;
				border-radius: 10px;
				background: #fff;
				box-shadow: 3px 2px 2px rgba(226,226,226,.6);
				font-size: 16px;
			}
			.num {
				position: absolute;
				left: 0;
				top: 50%;
				width: 62px;
				@include lh(62px);
				margin-top: -32px;
				border: 2px solid #f4bc16;
				border-radius: 50%;
				background: #fff;
				font-weight: bold;
				font-size: 60px;
				color: #fd2758;
			}
		}
	}
	.pro {
		height: 1574px - 46px;
		padding-top: 46px;
		background: url(../assets/agent/bg_02.png) center top no-repeat;
		.title {
			margin-bottom: 65px;
			h4 {
				margin-bottom: 14px;
			}
		}
		&-cont {
			@extend %width;
			@extend %clearfix;
		}
		&-title {
			h4 {
				width: 222px;
				@include lh(28px);
				background: #000;
				border-radius: 15px;
				border: 2px solid #f6cc50;
				margin-bottom: 24px - 8px;
				letter-spacing: 1px;
				font-size: 18px;
				color: #f6cc50;
			}
			p {
				line-height: 30px;
				text-align: justify;
				font-size: 16px;
			}
		}
		&-o {
			@extend %clearfix;
			padding: 0 30px 30px;
			border-bottom: 1px solid #b3b3b3;
			&-txt {
				float: right;
				width: 470px;
				padding-top: 5px;
				h4 {
					width: 284px;	
				}
			}
		}
		&-two {
			@extend %clearfix;
			padding: 24px 60px 30px 40px;
			border-bottom: 1px solid #b3b3b3;
			&-pic {
				float: right;
			}
			&-txt {
				float: left;
				width: 480px;
				padding-top: 15px;
			}
		}
		&-thr {
			@extend %clearfix;
			padding: 54px 40px;
			border-bottom: 1px solid #b3b3b3;
			&-pic {
				float: left;
			}
			&-txt {
				float: right;
				width: 510px;
				padding-top: 28px;
			}
		}
		&-four {
			@extend %clearfix;
			padding: 60px 40px 0;
			&-pic {
				float: right;
			}
			&-txt {
				float: left;
				width: 490px;
				padding-top: 24px;
			}
		}
	}
	.coo-o {
		height: 797px;
		background: url(../assets/agent/bg_03.png) center top no-repeat;
		&-cont {
			width: 575px;
			padding-top: 128px;
			margin-left: auto;
			position: relative;
			font-size: 16px;
			.title {
				margin-bottom: 38px;
				h4 {
					margin-bottom: 12px;
				}
			}
			&-pic {
				position: absolute;
				right: 74px;
				top: 88px;
			}
			&-list {
				li {
					width: 575px - 15px;
					height: 32px;
					line-height: 32px;
					padding-left: 15px;
					margin-bottom: 20px;
					border-radius: 10px;
					color: #fff;
				}
				.red {
					background: #e7364b;
				}
				.yellow {
					background: #e3b020;
				}
			}
			&-txt {
				padding-left: 47px;
				p {
					margin-bottom: 15px;
				}
			}
		}
	}
	.coo-two {
		height: 835px;
		background: url(../assets/agent/bg_04.png) center top no-repeat;
		&-cont {
			padding-top: 135px;
			padding-left: 40px;
			width: 360px;
			.title {
				text-align: left;
				margin-bottom: 78px;
				h4 {
					margin-bottom: 10px;
				}
				img{
					display: block;
					margin-bottom: 6px;
				}
			}
			p {
				margin-bottom: 28px;
				line-height: 26px;
				font-size: 16px;
			}
		}
	}
	.coo-thr {
		height: 818px;
		margin-bottom: 100px;
		background: url(../assets/agent/bg_05.png) center top no-repeat; 
		&-cont {
			padding-top: 38px;
			.title {
				margin-bottom: 54px;
				h4 {
					margin-bottom: 10px;
				}
				&-line {
					margin: 6px auto 0;
				}
			}
		}
		&-pic {
			display: block;
			margin: 0 auto 70px;
		}
	}
	.coo-four {
		background: url(../assets/agent/bg.png) center top no-repeat;
		.title {
			h4 {
				margin-bottom: 10px;
			}
			&-line {
				margin: 6px auto 0;
			}
		}
		p {
			padding: 88px 0 150px;
			text-align: center;
			font-weight: bold;
			font-size: 60px;
			color: #e7364b;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/Agent.vue